export default __webpack_public_path__ + "static/media/gaxon.a80523ea.svg";